import React from 'react';
import {Stack, SxProps} from "@mui/material"
import {AnyColumnJson} from "../../api/json/ColumnJson"
import CellInputWithHelperText from "../rows/CellInputWithHelperText"
import {AnyTemplateJson} from "../../api/json/TemplateJson"
import TemplateUtil from "../../library/TemplateUtil"

interface InferencePromptFormProps {
    columns: AnyColumnJson[]
    template: AnyTemplateJson
    cells: Record<string, string>
    updateCells: (cells: Record<string, string>) => void
    sx?: SxProps
}

function InferencePromptForm({columns, template, cells, updateCells, sx}: InferencePromptFormProps) {
    const promptReferences = TemplateUtil.findPromptReferences(template)
    const formFields = columns.filter(column => promptReferences.includes(column.reference)).sort((a, b) => a.order - b.order)

    const handleFieldValueChange = (key: string, newValue: string) => {
        let newFieldValuesByReference = {...cells}
        newFieldValuesByReference[key] = newValue
        updateCells(newFieldValuesByReference)
    }

    return (
        <Stack spacing={2} sx={sx}>
            {formFields.map((column, _) => {
                return <CellInputWithHelperText
                    key={column.id}
                    column={column}
                    value={cells[column.reference] ?? ""}
                    onChange={newValue => handleFieldValueChange(column.reference, newValue)}
                />
            })}
        </Stack>
    );
}

export default InferencePromptForm;